module.exports = __webpack_public_path__ + "static/media/home-page-hero-banner-mobile.a9a0bdba.png";